document.addEventListener('DOMContentLoaded', function () {
  // Selecciona todos los elementos con la clase ".multi-column__item"
  var multiColumnItems = document.querySelectorAll('.multi-column__item');

  // Itera sobre cada elemento y busca las imágenes dentro de ellos
  multiColumnItems.forEach(function (item) {
    var images = item.querySelectorAll('img');

    // Itera sobre cada imagen y elimina las clases específicas
    images.forEach(function (image) {
      image.classList.remove('zoom-image');
      image.classList.remove('group-hover:zoom');
    });
  });

  // Seleccionamos el elemento #size-chart y el contenedor x-modal .prose
  const sizeChart = document.querySelector('#size-chart');
  const modalProse = document.querySelector('x-modal .prose');
  const modalProseP = document.querySelector('x-modal .prose p');

  // Ocultamos el contenido dentro de x-modal .prose
  modalProseP.style.display = 'none';

  // Movemos #size-chart al contenedor x-modal .prose
  modalProse.appendChild(sizeChart);

  // Mostramos #size-chart estableciendo su estilo display a 'block'
  sizeChart.style.display = 'block';
});

var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}

/* ============================================================
   SOW: homepage Back to School carousel - show the tan cargo
   pant and the olive trumpet tee as the card images. Scoped to
   the homepage featured-collections section only, so collection
   pages keep their own colorway card images.
   ============================================================ */
(function () {
  var css = ''
    + "[id$='__featured_collections_J3T4gt'] product-card:has(a[href*='wide-leg-cargo']) .product-card__image--primary{content:url(https://cdn.shopify.com/s/files/1/0676/0624/9731/files/OW240043-tan-1.jpg?width=800)}"
    + "[id$='__featured_collections_J3T4gt'] product-card:has(a[href*='trumpet']) .product-card__image--primary{content:url(https://cdn.shopify.com/s/files/1/0676/0624/9731/files/SOW-t-shirt-with-trumpet-sleeve-front-military-olive.jpg?width=800)}";
  var st = document.createElement('style');
  st.textContent = css;
  document.head.appendChild(st);
})();

/* ============================================================
   SOW: color-matched recommendation thumbnails on product pages.
   The Related products / Pairs well with cards show each
   product's default image, which may be the wrong colorway.
   This looks up the color being viewed on the current product
   and swaps each recommended card's image and link to that
   product's matching colorway (exact color name match first,
   then partial). Falls back silently when no color matches.
   ============================================================ */
(function () {
  if (!/^\/products\//.test(location.pathname)) return;

  var cache = {};
  function pdata(handle) {
    if (!cache[handle]) {
      cache[handle] = fetch('/products/' + handle + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return cache[handle];
  }
  function norm(s) { return (s || '').toString().trim().toLowerCase(); }
  function colorIndex(p) {
    if (!p.options) return 0;
    for (var j = 0; j < p.options.length; j++) {
      var n = (p.options[j] && p.options[j].name ? p.options[j].name : p.options[j] || '').toString();
      if (/colou?r/i.test(n)) return j;
    }
    return 0;
  }
  function currentColor(cb) {
    var handle = location.pathname.split('/products/')[1].split('/')[0];
    pdata(handle).then(function (p) {
      if (!p || !p.variants || !p.variants.length) return;
      var ci = colorIndex(p);
      var vid = new URLSearchParams(location.search).get('variant');
      var v = null;
      if (vid) { for (var i = 0; i < p.variants.length; i++) { if (String(p.variants[i].id) === vid) { v = p.variants[i]; break; } } }
      if (!v) {
        var inp = document.querySelector('form[is="product-form"] input[name="id"]');
        if (inp && inp.value) { for (var k = 0; k < p.variants.length; k++) { if (String(p.variants[k].id) === inp.value) { v = p.variants[k]; break; } } }
      }
      if (!v) v = p.variants[0];
      cb(norm(v['option' + (ci + 1)]), handle);
    });
  }
  function matchVariant(p, color) {
    var key = 'option' + (colorIndex(p) + 1);
    var exact = null, partial = null;
    for (var i = 0; i < p.variants.length; i++) {
      var c = norm(p.variants[i][key]);
      if (c === color) { exact = p.variants[i]; break; }
      if (!partial && c && color && (c.indexOf(color) !== -1 || color.indexOf(c) !== -1)) partial = p.variants[i];
    }
    return exact || partial;
  }
  function run() {
    currentColor(function (color, ownHandle) {
      if (!color) return;
      document.querySelectorAll('product-card').forEach(function (card) {
        var a = card.querySelector('a[href*="/products/"]');
        if (!a) return;
        var mh = (a.getAttribute('href') || '').match(/\/products\/([^?\/#]+)/);
        if (!mh || mh[1] === ownHandle) return;
        if (card.dataset.sowColorMatch === color) return;
        pdata(mh[1]).then(function (p) {
          if (!p) return;
          var v = matchVariant(p, color);
          if (!v) return;
          card.dataset.sowColorMatch = color;
          if (v.featured_image && v.featured_image.src) {
            card.querySelectorAll('.product-card__image--primary').forEach(function (img) {
              img.removeAttribute('srcset');
              img.src = v.featured_image.src;
            });
          }
          card.querySelectorAll('a[href*="/products/"]').forEach(function (link) {
            var base = link.getAttribute('href').split('#')[0].split('?')[0];
            link.setAttribute('href', base + '?variant=' + v.id);
          });
        });
      });
    });
  }
  var t = null;
  function queue() { if (t) return; t = setTimeout(function () { t = null; run(); }, 200); }
  new MutationObserver(queue).observe(document.body, { childList: true, subtree: true });
  document.addEventListener('change', queue);
  if (document.readyState !== 'loading') { queue(); } else { document.addEventListener('DOMContentLoaded', queue); }
})();

/* ============================================================
   SOW: per-colorway sold-out badges on collection pages.
   The colorway app splits products into one card per color but
   only the whole product's availability drives the theme badge.
   This checks the specific color of each split card and adds a
   Sold Out badge when every size of that color is unavailable.
   The app upgrades cards in place (adds ?variant= to the link
   later), so cards without a variant are left unmarked and get
   rechecked on every rescan.
   ============================================================ */
(function () {
  var css = '.sow-soldout-badge{position:absolute;top:10px;left:10px;z-index:2;background:rgba(28,28,26,.85);color:#fff;font-size:10px;letter-spacing:1.5px;text-transform:uppercase;padding:4px 8px;pointer-events:none;}';
  var st = document.createElement('style');
  st.textContent = css;
  document.head.appendChild(st);

  var cache = {};
  function productData(handle) {
    if (!cache[handle]) {
      cache[handle] = fetch('/products/' + handle + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return cache[handle];
  }

  function checkCard(card) {
    var a = card.querySelector('a[href*="/products/"]');
    if (!a) return;
    var href = a.getAttribute('href') || '';
    var mh = href.match(/\/products\/([^?\/#]+)/);
    var mv = href.match(/[?&]variant=(\d+)/);
    if (!mh || !mv) return; /* not a split colorway card yet; recheck later */
    var vid = mv[1];
    if (card.dataset.sowSoldout === vid) return; /* already handled this colorway */
    card.dataset.sowSoldout = vid;
    productData(mh[1]).then(function (p) {
      if (!p || !p.variants) return;
      var v = null;
      for (var i = 0; i < p.variants.length; i++) {
        if (String(p.variants[i].id) === vid) { v = p.variants[i]; break; }
      }
      if (!v) return;
      var ci = 0;
      if (p.options) {
        for (var j = 0; j < p.options.length; j++) {
          var n = (p.options[j] && p.options[j].name ? p.options[j].name : p.options[j] || '').toString();
          if (/colou?r/i.test(n)) { ci = j; break; }
        }
      }
      var key = 'option' + (ci + 1);
      var color = v[key];
      var anyAvail = p.variants.some(function (x) { return x[key] === color && x.available; });
      var fig = card.querySelector('.product-card__figure') || card;
      var existing = fig.querySelector('.sow-soldout-badge');
      var themeBadge = card.querySelector('sold-out-badge:not([hidden])');
      if (themeBadge) { if (existing) { existing.remove(); } return; }
      if (!anyAvail) {
        if (getComputedStyle(fig).position === 'static') { fig.style.position = 'relative'; }
        if (!existing) {
          var b = document.createElement('span');
          b.className = 'sow-soldout-badge';
          b.textContent = 'Sold out';
          fig.appendChild(b);
        }
      } else if (existing) {
        existing.remove();
      }
    });
  }

  function scan() {
    document.querySelectorAll('product-list product-card').forEach(checkCard);
  }

  function init() {
    var list = document.querySelector('product-list');
    if (!list) return;
    scan();
    var t = null;
    new MutationObserver(function () {
      if (t) return;
      t = setTimeout(function () { t = null; scan(); }, 150);
    }).observe(list, { childList: true, subtree: true, attributes: true, attributeFilter: ['href', 'class'] });
  }

  if (document.readyState !== 'loading') { init(); } else { document.addEventListener('DOMContentLoaded', init); }
})();
